import React, { useEffect, useState } from "react";
import { setAppError } from "../../store/userSlice";
import { useDispatch } from "react-redux";
import nodeinstance from "../../nodeInstance";
import { sortByName } from "../../utils/sortByName";

export default function FilterDropDown({
  title,
  url,
  onChange,
  token,
  selectedStatus,
  options, // ADD: support for static options
}) {
  const [dropDoenList, SetDropDownList] = React.useState(options || []);
  const dispatch = useDispatch();
  useEffect(() => {
    if (url) {
      getDropDownListData();
    }
  }, [url]);

  const getDropDownListData = async () => {
    try {
      const result = await nodeinstance.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = result?.data?.data;
      SetDropDownList(sortByName(data));
    } catch (error) {
      dispatch(setAppError({ msg: `${error?.message}` }));
    }
  };
  return (
    <>
      <select
        className="select select-sm select-bordered uppercase h-10 w-48"
        value={selectedStatus}
        onChange={(e) => onChange(e)}
      >
        <option value=""> {title}</option>
        {dropDoenList.map((filetype, index) => (
          <option key={filetype?.id || index} value={filetype?.value || filetype?.name}>
            {filetype?.label || filetype?.name}
          </option>
        ))}
      </select>
    </>
  );
}
